import React, { useEffect, useState } from 'react';
import productsData from '../../data/products.json';
import ProductCard from '../../components/ProductCard';
import ShopByConcern from '../../components/ShopByConcern';

const OilSkinPage = () => {
  const [oilSkinProducts, setOilSkinProducts] = useState([]);

  useEffect(() => {
    const filtered = productsData.products.filter(
      (product) => product.concern?.includes('oilskin')
    );
    setOilSkinProducts(filtered);
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Oil Skin Concern Products</h1>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8">
        {oilSkinProducts.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
      <ShopByConcern/>
    </div>
  );
};

export default OilSkinPage;
